module.exports = __webpack_public_path__ + "static/img/CO2.9d5045ea.png";